import {connect} from "react-redux";
import {removeBeneficiary, updateCartBeneficiary} from "../../../../actions/action";
import BeneficiaryList from '../component/BeneficiaryList';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{

    return{
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        removeBeneficiary : (obj) => {
            return removeBeneficiary(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        },
        updateCartBeneficiary : (obj) =>{
            return updateCartBeneficiary(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryList)